import {
  useAddLanguageListMutation,
  useEditLanguageListMutation,
  useGetLanguageQuery,
  useLanguageListChangeStatusMutation,
  useLanguageListDeleteMutation,
  useLazyLanguageDetailsQuery,
  useLazyLanguageListQuery,
} from "store/api/master";
import { fixedCacheKeys } from "utils/fixedCacheKeys";

export const useLanguageHook = () => {
  /** ***************** 
  @purpose : Used For handle get and reset data
  @Parameter : {data,reset}
  @Author : INIC
  ***************** */

  const { data: languageData } = useGetLanguageQuery();

  const [
    languageList,
    { data: languageListData, isUninitialized: isLanguageListUninitialized },
  ] = useLazyLanguageListQuery();

  const [languageListChangeStatus] = useLanguageListChangeStatusMutation({
    fixedCacheKey: fixedCacheKeys.LANGUAGE_LIST_CHANGE_STATUS,
  });

  const [languageListDelete] = useLanguageListDeleteMutation({
    fixedCacheKey: fixedCacheKeys.COUNTRY_LIST_DELETE,
  });

  const [addLanguageList, { isLoading: addLanguageListLoader }] =
    useAddLanguageListMutation({
      fixedCacheKey: fixedCacheKeys.ADD_COUNTRYLIST,
    });

  const [editLanguageList, { isLoading: editLanguageLoader }] =
    useEditLanguageListMutation({
      fixedCacheKey: fixedCacheKeys.EDIT_LANGUAGELIST,
    });

  const [LanguageDetails, { data: LanguageDetailsData }] =
    useLazyLanguageDetailsQuery({
      fixedCacheKey: fixedCacheKeys.DETAIL_LANGUAGELIST,
    });

  return {
    languageList,
    languageData,
    languageListData,
    languageListChangeStatus,
    languageListDelete,
    addLanguageList,
    addLanguageListLoader,
    isLanguageListUninitialized,
    editLanguageList,
    editLanguageLoader,
    LanguageDetails,
    LanguageDetailsData,
  };
};
